/* unplugin-vue-components disabled */import { render } from "./aboutTab.vue?vue&type=template&id=3eaa279c&scoped=true"
import script from "./aboutTab.vue?vue&type=script&lang=js"
export * from "./aboutTab.vue?vue&type=script&lang=js"

import "./aboutTab.vue?vue&type=style&index=0&id=3eaa279c&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eaa279c"]])

export default __exports__